(function () {
  'use strict';
  /* v2.81 speed (31 Oct 2026, laptop trace: every second this timer rewrote its text nodes, and each write made the
     browser redo the whole page's styles, about 285 ms on a phone). Now only the characters of the existing text change,
     and only when they differ. */
  function fbSetText(el, s) {
    if (!el) return;
    s = String(s);
    var t = el.firstChild;
    if (t && t.nodeType === 3 && !t.nextSibling) { if (t.data !== s) t.data = s; }
    else if (el.textContent !== s) el.textContent = s;
  }

  if (window.FrenlyWeekendLive) return;

  var AEST_OFFSET = 10 * 60 * 60 * 1000;
  var DAY = 24 * 60 * 60 * 1000;
  var timer = null;
  var nodes = [];

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function aestParts(timestamp) {
    var date = new Date(timestamp + AEST_OFFSET);
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth(),
      date: date.getUTCDate(),
      day: date.getUTCDay(),
    };
  }

  function atAest(parts, hour) {
    return Date.UTC(parts.year, parts.month, parts.date, hour, 0, 0, 0) - AEST_OFFSET;
  }

  function windowForDay(timestamp) {
    var parts = aestParts(timestamp);
    if (parts.day !== 0 && parts.day !== 6) return null;

    // SNEED 2.0 (24 Sep 2026, Marshall lock): Sat 9am to 9pm, Sun 9am to 5pm AEST.
    var startHour = 9;
    var endHour = parts.day === 6 ? 21 : 17;

    // The promoted $100K August Mega has an earlier advertised start.
    if (parts.year === 2026 && parts.month === 7 && parts.date === 29) startHour = 8;

    return {
      start: atAest(parts, startHour),
      end: atAest(parts, endHour),
    };
  }

  function state(now) {
    var today = windowForDay(now);
    if (today && now >= today.start && now < today.end) {
      return { live: true, target: today.end };
    }

    for (var index = 0; index < 9; index += 1) {
      var candidate = windowForDay(now + index * DAY);
      if (candidate && candidate.start > now) {
        return { live: false, target: candidate.start };
      }
    }

    return { live: false, target: 0 };
  }

  function countdown(target, now) {
    var seconds = Math.max(0, Math.floor((target - now) / 1000));
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    var remainingSeconds = seconds % 60;
    return (days ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(remainingSeconds);
  }

  function refreshNodes() {
    // Adopt the legacy announcement-bar hook as well, then remove it so the
    // older shared timer cannot overwrite this schedule a moment later.
    Array.prototype.forEach.call(document.querySelectorAll('[data-fb-live]'), function (node) {
      node.removeAttribute('data-fb-live');
      node.setAttribute('data-fb-weekend-live', '');
    });
    nodes = Array.prototype.slice.call(document.querySelectorAll('[data-fb-weekend-live]'));
  }

  // FIX 2026-09-11: tick() used to bail out completely whenever
  // document.hidden was true (a background tab, a prerendered tab, or any
  // headless/automated load that never becomes the focused tab), which left
  // the span permanently empty because every later interval tick re-checked
  // the same document.hidden and bailed again forever - the visibility
  // check never gets a chance to "expire". document.hidden should only
  // skip the recurring work done to save CPU while backgrounded; the very
  // first render after refreshNodes() must always write a real value so the
  // countdown never stays blank longer than the interval says. Pass
  // force=true for that first call (and for the shopify:section:load
  // re-init, which is effectively a fresh first render for that section).
  function tick(force) {
    if (!nodes.length) return;
    if (document.hidden && !force) return;
    var now = Date.now();
    var current = state(now);
    var text = current.live ? 'LIVE NOW' : (current.target ? countdown(current.target, now) : '--:--:--');

    nodes.forEach(function (node) {
      fbSetText(node, text);
      var al = current.live ? 'Frenly Bricks is live now on eBay' : 'Time until the next Frenly Bricks eBay Live stream';
      if (node.getAttribute('aria-label') !== al) node.setAttribute('aria-label', al);
    });
    document.documentElement.classList.toggle('fb-live-now', current.live);
    document.querySelectorAll('[data-fb-stream-badge]').forEach(function (badge) { fbSetText(badge, current.live ? 'Live now' : 'Upcoming'); });
  }

  function start() {
    refreshNodes();
    tick(true);
    if (nodes.length && !timer) timer = window.setInterval(tick, 1000);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
  document.addEventListener('visibilitychange', function () { tick(true); });
  document.addEventListener('shopify:section:load', function () {
    refreshNodes();
    tick(true);
    if (nodes.length && !timer) timer = window.setInterval(tick, 1000);
  });

  // Single schedule source for every eBay Live time on the site
  // (header countdown, carousel, /pages/ebay-live-watch). Returns the next
  // stream window that has not finished yet, as epoch ms, or null.
  function nextWindow(now) {
    for (var index = 0; index < 9; index += 1) {
      var candidate = windowForDay(now + index * DAY);
      if (candidate && candidate.end > now) return candidate;
    }
    return null;
  }

  window.FrenlyWeekendLive = { state: state, tick: tick, refreshNodes: refreshNodes, nextWindow: nextWindow, windowForDay: windowForDay };
})();
